/**
 * TeamFace 平台参数配置
 * 用于统一管理 TeamFace 相关的加密密钥和配置参数
 */
export const TF_PARAMETER = {
    /** AES 加密密钥 */
    AES_PWD: 'teamface2019team',
    /** TEAM_FACE_PWD 平台密钥 */
    TEAM_FACE_PWD: 'hjhq2017Teamface'
    /** 客户端标识 */
};
/**
 * 所有可用的 TeamFace 参数键
 */
export const TF_PARAMETER_KEYS = Object.keys(TF_PARAMETER);
/**
 * 所有可用的 TeamFace 参数值
 */
export const TF_PARAMETER_VALUES = Object.values(TF_PARAMETER);
/**
 * 验证参数键是否有效
 * @param key - 要验证的参数键
 * @returns 是否为有效的参数键
 */
export function isValidTFParameterKey(key) {
    return TF_PARAMETER_KEYS.includes(key);
}
/**
 * 获取参数键的中文描述
 * @param key - 参数键
 * @returns 中文描述
 */
export function getTFParameterLabel(key) {
    const labels = {
        AES_PWD: 'AES 加密密钥',
        TEAM_FACE_PWD: 'TeamFace 平台密钥'
    };
    return labels[key] || '未知';
}
